import { create } from "zustand";

interface IAdSlotsState {
  seenCameras: number[];
  addSeenCamera: (id: number) => void;
}

export const useStreamateCamerasStore = create<IAdSlotsState>(
  (set) => ({
    seenCameras: [],
    addSeenCamera: (id: number) => set(({ seenCameras }) => ({
      seenCameras: [
        ...seenCameras.filter(item => item !== id),
        id
      ]
    })),
  }),
);
